import { useMemo } from 'react'

import { getSavedDetailsForOffer } from 'tripPlanner/components/Bookmark/BookmarkButton/utils'
import { useEditableTrips } from 'tripPlanner/hooks/api/trip'
import { EmptyArray } from 'lib/array/arrayUtils'
import SavePrompt from './SavePrompt'
import useNewTripNameFromOffer from 'tripPlanner/hooks/useNewTripNameFromOffer'
import useShouldShowTripPlannerSaveEntryPoints from 'tripPlanner/hooks/useShouldShowTripPlannerSaveEntryPoints'
import type { CruiseBookmarkPayload } from 'tripPlanner/api/bookmark/types'
import type { BasicTrip } from 'tripPlanner/types/common'

interface Props {
  offer: App.CruiseOffer
}

function SavePromptCruise({ offer }: Props) {
  const shouldShowTripPlannerSaveEntryPoints =
    useShouldShowTripPlannerSaveEntryPoints()
  const { data, isSuccess: tripsFetched } = useEditableTrips({
    enabled: shouldShowTripPlannerSaveEntryPoints,
  })
  const trips = data ?? EmptyArray as Array<BasicTrip>

  const details = getSavedDetailsForOffer(trips, offer.id)
  const isSaved = details.length > 0

  const newTripName = useNewTripNameFromOffer(
    offer,
    shouldShowTripPlannerSaveEntryPoints,
  )

  const bookmarkPayload = useMemo<CruiseBookmarkPayload>(() => ({
    type: 'cruise_v2',
    code: offer.id,
  }), [offer.id])

  if (!shouldShowTripPlannerSaveEntryPoints || isSaved || !tripsFetched) {
    return null
  }

  return <SavePrompt
    offerId={offer.id}
    offerType="cruise"
    bookmarkPayload={bookmarkPayload}
    newTripName={newTripName}
    trips={trips}
  />
}

export default SavePromptCruise
